import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { ArticleTemplateQuery } from '../../../graphql-types';

import * as styles from './article.module.scss';
import { usePageContext } from '../../hooks/contexts/usePageContext';
import { HeaderIntro } from '../../components/2.0version/headerIntro/HeaderIntro';
import { ArticleContent } from './contentEdito/ArticleContent';
import { SEO } from '../../components/2.0version/seo/Seo';

interface IArticleProps {
  data?: ArticleTemplateQuery;
  otList?: ArticleTemplateQuery['allIngenieOt'];
}

export const Article = ({ data, otList }: IArticleProps) => {
  const { lang } = usePageContext();
  const image = getImage(data?.sanityIncontournablesItem?.image?.image?.asset?.gatsbyImageData);

  const article = data?.sanityIncontournablesItem?.id
    ? data?.sanityIncontournablesItem
    : data?.sanityBlogArticle;

  return (
    <div className={styles.wrapper}>
      <SEO rawMeta={article?._rawMetadata} />
      <HeaderIntro
        title={article?.pageHeader?._rawTitle?.[lang]}
        description={article?.pageHeader?._rawDescription?.text?.[lang]}
      />
      {image ? (
        <div className={styles.image}>
          <GatsbyImage image={image} alt={article?.image?.alt ?? 'Tours incontournable'} />
        </div>
      ) : null}
      <ArticleContent content={article?.content} otList={otList} />
    </div>
  );
};
